export default "__VITE_ASSET__Dp24j9sT__"